import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { getSteemLuckNumUserAirDrop } from "../apis/services/steemActivity";
import { claimWithUserNameAndPassword, claimWithSteemKeychain } from "../unit/boylikegirlcluboperUtil";
import { extractLoginData } from "../unit/UserUtil";
import { ElMessage, ElLoading } from "element-plus";
export default {
  props: ["steemLuckNumAirDrop"],
  name: "social-traffic-table",
  data: function data() {
    return {
      isLogin: false,
      airDropInfo: null,
      luckNumAirDrop: null,
      loadingInstance: null
    };
  },
  methods: {
    loadAccount: function loadAccount(newVal) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var loginData, account;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.luckNumAirDrop = newVal;
                loginData = extractLoginData();

                if (!loginData) {
                  _context.next = 9;
                  break;
                }

                _this.isLogin = true;
                account = loginData[0];
                _context.next = 7;
                return getSteemLuckNumUserAirDrop(account, _this.luckNumAirDrop.id);

              case 7:
                _this.airDropInfo = _context.sent.data;

                if (_this.loadingInstance) {
                  _this.loadingInstance.close();
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    claimedAirDrop: function claimedAirDrop() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var loginData, account, isUseSteemKeychain, password;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                loginData = extractLoginData();

                if (loginData) {
                  _context2.next = 4;
                  break;
                }

                _this2.$bus.emit("openLogin");

                return _context2.abrupt("return");

              case 4:
                if (!(_this2.airDropInfo.airDropPrize == 0)) {
                  _context2.next = 7;
                  break;
                }

                ElMessage.error(_this2.$t("error.noAirDrop"));
                return _context2.abrupt("return");

              case 7:
                if (!_this2.airDropInfo.isClaimed) {
                  _context2.next = 10;
                  break;
                }

                ElMessage.error(_this2.$t("error.airDropClaimed"));
                return _context2.abrupt("return");

              case 10:
                _this2.loadingInstance = ElLoading.service({
                  fullscreen: true
                });

                if (!loginData) {
                  _context2.next = 22;
                  break;
                }

                account = loginData[0];
                isUseSteemKeychain = loginData[4];
                password = loginData[1];

                if (!isUseSteemKeychain) {
                  _context2.next = 20;
                  break;
                }

                _context2.next = 18;
                return claimWithSteemKeychain(account, _this2.luckNumAirDrop.id, _this2.claimCallback);

              case 18:
                _context2.next = 22;
                break;

              case 20:
                _context2.next = 22;
                return claimWithUserNameAndPassword(account, password, _this2.luckNumAirDrop.id, _this2.claimCallback);

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    claimCallback: function claimCallback(result) {
      if (result.code == 0) {
        ElMessage({
          message: this.$t("success." + result.message),
          type: "success"
        });
      } else {
        ElMessage.error(this.$t("error." + result.message));
      }

      this.loadAccount(this.luckNumAirDrop);
    },
    goToRank: function goToRank() {
      this.$router.push({
        path: "/lucknumairdroprank",
        query: {
          id: this.luckNumAirDrop.id,
          title: this.luckNumAirDrop.title
        }
      });
    }
  },
  watch: {
    steemLuckNumAirDrop: function steemLuckNumAirDrop(newVal) {
      this.loadAccount(newVal);
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this3.loadAccount(_this3.steemLuckNumAirDrop);

              _this3.$bus.on("loginScuccess", function () {
                _this3.loadAccount(_this3.steemLuckNumAirDrop);
              });

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};